import { Injectable } from '@angular/core';
import { AccountModel } from '@app/models';
import { DataService, ErrorDialogService } from '@app/core/services/root';
import { GoogleAnalyticsService } from '@app/core/services/google-analytics.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

declare let window: any;

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public userData: any;
    public userFoundByEmail = false;

    constructor(
        private errorDialogService: ErrorDialogService,
        private dataService: DataService,
        private gaService: GoogleAnalyticsService,
        private http: HttpClient,
        private router: Router
    ) { }

    public initialize() {
        window.setLoginCustomCallback( ( data ) => {
            const gigyaAccount = window.getAccount();
            const navigateTo = localStorage.getItem('gdhPreviousURL') ? localStorage.getItem('gdhPreviousURL') : '/enroll'
            if (gigyaAccount.isLoggedIn && this.router.url === '/welcome') {
                localStorage.removeItem('gdhPreviousURL');
                this.router.navigate([navigateTo]);                
            }
        });
    }

    public setTFAWithLucienValue(): void {
        // SETS THE TFA option on the gigya service
        // if (this.lucienDataService.appDisplayConfig) {
        //     window.setAppTFAOptIn(this.lucienDataService.convertTFAOptionValue());
        // }
    }

    public retrieveAccount(): AccountModel {
        const gigyaAccount = window.getAccount();
        const customerKey = gigyaAccount.customerKey;
        const id = gigyaAccount.id;
        return new AccountModel(+customerKey, id);
    }

    public retrieveAccountName() {
        const gigyaAccount = window.getAccount();
        return gigyaAccount.displayName;
    }

    public getUserGigyaData() {
        const gigyaAccount = window.getAccount();
        const displayname = this.retrieveAccountName();
        const firstname = displayname ? displayname.split(' ').slice(0, 1).join(' ') : '';
        const lastname = displayname ? displayname.split(' ').slice(1).join(' ') : '';
        return {
            'email': gigyaAccount.name,
            'fullName': displayname,
            'firstName': firstname,
            'lastName': lastname
        };
    }

    public getIPAddress(): any {
        return this.http.get("https://api.ipify.org/?format=json").toPromise();
    }

    public getSessionId(): string {
        return window.getAccount()?.session;
    }

    public isUserLoggedNoAction(): boolean {
        const gigyaAccount = window.getAccount();
        return gigyaAccount.isLoggedIn;
    }

    public isUserLogged(): boolean {
        const gigyaAccount = window.getAccount();
        if (!gigyaAccount.isLoggedIn) {
            this.showLoginScreenset();
        }
        return gigyaAccount.isLoggedIn;
    }

    public get clientSessionId(): string {
        return window.getAccount()?.session;
    }

    public showLoginScreenset(): void {
        window.showPopups();
    }

    public validateUser(): boolean {
        if (this.userFoundByEmail && this.isUserLogged()) {
            const gigyaData = this.getUserGigyaData();

            if (gigyaData.email.includes(' ')) {
                gigyaData.email = gigyaData.email.split(' ')[0];
            }

            if (
                this.userData?.name[0]?.full === gigyaData?.fullName &&
                this.userData?.name[0]?.first === gigyaData?.firstName &&
                this.userData?.name[0]?.last === gigyaData?.lastName &&
                this.userData?.email[0] === gigyaData?.email
            ) {
                return true;
            }

            return false;

        }

        if (!this.userFoundByEmail && this.isUserLogged()) {
            return true;
        }

        return false;
    }

}
